/* eslint-disable react/no-unescaped-entities */
import React, { memo, useEffect, useState } from 'react';
import GaugeChart from '@components/gaugeChart';
import { Button, Form } from 'antd';
import { connect } from 'react-redux';
import actions from '@flux/action';
import GaugeCard, {
  SECTION_LEVEL_PREFIX,
  SECTION_SUMMARY_PREFIX,
} from '@modules/questionnaires/complexity/sections/overall/components/gaugeCard';
import { Prompt, withRouter } from 'react-router-dom';
import alert from '@components/alert';
import { QUES_SECTIONS_KEYS } from '@model/questionmaires/questionnaire';
import { getSessionStorage } from '@utils/windowUtil';

export function findSectionData(sectionComplexity = [], seqNum) {
  return sectionComplexity.find((i) => i.seqNum === seqNum);
}

function Overall({
  isEditing,
  currentMode,
  // selectMode,
  handleEdit,
  handleCancel,
  isLoading,
  form,
  // modelsData,
  data,
  handleSubmit,
  history,
  changeSideBarLevel,
}) {
  const isManual = currentMode === 'manual';
  const showModalSave = (location) => {
    alert.confirmWithSave({
      onOk() {
        if (isEditing) {
          handleSubmit();
        }
      },
      onCancel(close) {
        if (isEditing) {
          handleCancel();
        }
        close();
        window.localStorage.removeItem('prompt');
        history.push({
          pathname: `${location.pathname}`,
        });
      },
    });
  };
  const handlePrompt = (location) => {
    const e = window.localStorage.getItem('prompt');
    if (e) {
      showModalSave(location);
      return false;
    }
    return true;
  };
  const [initData, setInitData] = useState(data);

  useEffect(() => {
    if (isEditing) {
      const formResult = form.getFieldsValue(true);
      const { overallComplexity, sectionComplexity = [] } = data;

      const nextFormData = {
        level: overallComplexity?.levelPercent || overallComplexity?.level,
      };
      sectionComplexity.forEach((sectionItem) => {
        nextFormData[`${SECTION_LEVEL_PREFIX}${sectionItem.seqNum}`] =
          sectionItem.levelPercent;
        nextFormData[`${SECTION_SUMMARY_PREFIX}${sectionItem.seqNum}`] =
          sectionItem.summary;
      });
      form.setFieldsValue({ ...formResult, ...nextFormData });
      window.localStorage.setItem('prompt', true);
    } else {
      window.localStorage.removeItem('prompt');
    }

    return () => {
      window.localStorage.removeItem('prompt');
    };
  }, [isEditing, data]);

  useEffect(() => {
    setInitData(data);
  }, [data]);

  useEffect(() => {
    form.resetFields();
    if (getSessionStorage('editMode')) {
      setTimeout(handleEdit, 1);
      window.SessionStorage.removeItem('editMode');
    }
  }, [initData]);

  return (
    <div className="complexity-overall">
      <Prompt message={handlePrompt} />
      <div
        className="complexity-overall-center-wrapper"
        style={!isManual ? { marginBottom: 30 } : {}}
      >
        <Form.Item
          noStyle
          name="level"
          initialValue={initData.overallComplexity?.levelPercent}
        >
          <GaugeChart
            size="big"
            isManual={isManual}
            isEditing={isEditing && isManual}
            onChange={(percent) => changeSideBarLevel('overall', percent)}
          />
        </Form.Item>
      </div>
      <div className="complexity-overall-button-wrapper">
        {isEditing ? (
          <>
            <Button
              className="edit-btn"
              loading={isLoading}
              onClick={() => {
                form.resetFields();
                handleCancel();
              }}
            >
              Cancel
            </Button>
            <Button type="primary" loading={isLoading} onClick={handleSubmit}>
              Save
            </Button>
          </>
        ) : (
          <Button
            className="edit-btn role-control"
            danger
            size="middle"
            loading={isLoading}
            onClick={handleEdit}
          >
            Edit
          </Button>
        )}
      </div>
      <div className="complexity-overall-card-wrapper">
        <GaugeCard
          title={QUES_SECTIONS_KEYS.StrategyValue}
          isEditing={isEditing}
          isManual={isManual}
          seqNum={1}
          cardData={findSectionData(initData.sectionComplexity, 1)}
          onGaugeChange={(percent) => {
            changeSideBarLevel(QUES_SECTIONS_KEYS.StrategyValue, percent);
          }}
          onClickPlaceholder={handleEdit}
          gaugeEditable={isManual}
          editorProps={{
            linkPopoverProps: {
              placement: 'leftTop',
              overlayClassName:
                'lifecycle-link-popover complexity-overall-link-adjust',
            },
          }}
        />
        <GaugeCard
          title={QUES_SECTIONS_KEYS.OrganizationPeople}
          isEditing={isEditing}
          isManual={isManual}
          seqNum={2}
          cardData={findSectionData(initData.sectionComplexity, 2)}
          onGaugeChange={(percent) => {
            changeSideBarLevel(QUES_SECTIONS_KEYS.OrganizationPeople, percent);
          }}
          onClickPlaceholder={handleEdit}
          gaugeEditable={isManual}
          editorProps={{
            linkPopoverProps: {
              placement: 'leftTop',
            },
          }}
        />
        <GaugeCard
          title={QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations}
          isEditing={isEditing}
          isManual={isManual}
          seqNum={3}
          cardData={findSectionData(initData.sectionComplexity, 3)}
          onGaugeChange={(percent) => {
            changeSideBarLevel(
              QUES_SECTIONS_KEYS.EnterpriseIntegrationConsiderations,
              percent,
            );
          }}
          onClickPlaceholder={handleEdit}
          gaugeEditable={isManual}
          editorProps={{
            linkPopoverProps: {
              placement: 'leftTop',
            },
          }}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  changeSideBarLevel(section, levelPercent) {
    dispatch(actions.changeSidebarSectionLevel({ section, levelPercent }));
  },
});

export default connect(null, mapDispatchToProps)(memo(withRouter(Overall)));
